// extracted by mini-css-extract-plugin
export var buttons = "style-module--buttons--36067";
export var captcha = "style-module--captcha--e1ab5";
export var download = "style-module--download--3a646";
export var orderForm = "style-module--orderForm--be701";
export var quickOrder = "style-module--quickOrder--e19cb";
export var step = "style-module--step--33831";
export var uploadWrapper = "style-module--uploadWrapper--6292b";